import { render, staticRenderFns } from "./GroupClient.vue?vue&type=template&id=f2a86bb2&"
import script from "./GroupClient.vue?vue&type=script&lang=js&"
export * from "./GroupClient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports